import { defineComponent as _defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue';
import { makeFormModel, batchSetState } from 'ah-common-lib/src/form/helpers';
import { selectField, radioField } from 'ah-common-lib/src/form/models';
import { subYears, startOfYear, getDaysInMonth, endOfDay, startOfDay } from 'date-fns';
import { ExportListType, PaginatedQuery } from 'ah-api-gateways';
import { CommissionDisplayType } from 'ah-api-gateways';
import { reactive, ref, computed, onBeforeMount } from 'vue';
import { FormDefinition } from 'ah-common-lib/src/form/interfaces';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useTradeState } from '../..';


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadPartnerCommissionsStatementModal',
  setup(__props) {

const tradeState = useTradeState();
const requestManager = useRequestManager().manager;

const downloadStatementFormModal = ref<BModal | null>(null);

const apportionedForm = reactive<FormDefinition>({
  form: makeFormModel({
    name: 'apportionedForm',
    fieldType: 'form',
    fields: [
      radioField(
        'isApportioned',
        '',
        [
          { value: CommissionDisplayType.ORIGINAL, label: 'Original' },
          { value: CommissionDisplayType.APPORTIONED, label: 'Apportioned' },
        ],
        {
          required: true,
          clearValue: '',
          defaultValue: CommissionDisplayType.ORIGINAL,
          inline: true,
        }
      ),
    ],
  }),
  validation: null,
});

const monthForm = reactive<FormDefinition>({
  form: makeFormModel({
    name: 'monthForm',
    fieldType: 'form',
    fields: [
      selectField(
        'month',
        '',
        [
          { value: 0, label: 'January' },
          { value: 1, label: 'February' },
          { value: 2, label: 'March' },
          { value: 3, label: 'April' },
          { value: 4, label: 'May' },
          { value: 5, label: 'June' },
          { value: 6, label: 'July' },
          { value: 7, label: 'August' },
          { value: 8, label: 'September' },
          { value: 9, label: 'October' },
          { value: 10, label: 'November' },
          { value: 11, label: 'December' },
        ],
        {
          required: true,
          clearValue: '',
          placeholder: 'Month',
        }
      ),
    ],
  }),
  validation: null,
});

const yearForm = reactive<FormDefinition>({
  form: makeFormModel({
    name: 'year',
    fieldType: 'form',
    fields: [
      selectField('year', '', [], {
        required: true,
        clearValue: '',
        placeholder: 'Year',
      }),
    ],
  }),
  validation: null,
});

const isApportioned = computed(() => apportionedForm.form.isApportioned === CommissionDisplayType.APPORTIONED);

onBeforeMount(() => {
  const startDate = startOfYear(subYears(new Date(), 5));
  const years = [];
  let currentYear = new Date().getFullYear();

  while (currentYear >= startDate.getFullYear()) {
    years.push({ value: currentYear, label: currentYear.toString() });
    currentYear -= 1;
  }

  batchSetState(yearForm.form, 'options', {
    year: years,
  });
});

function showModal() {
  downloadStatementFormModal.value?.show();
}

function download(type: ExportListType) {
  if (!monthForm.validation?.$invalid && !yearForm.validation?.$invalid) {
    const monthDays = getDaysInMonth(new Date(yearForm.form.year, monthForm.form.month));
    const startDate = new Date(yearForm.form.year, monthForm.form.month, 1);
    const endDate = new Date(yearForm.form.year, monthForm.form.month, monthDays);

    const query = {
      tradeDateFrom: startOfDay(startDate),
      tradeDateTo: endOfDay(endDate),
      apportioned: isApportioned.value,
    } as PaginatedQuery;

    requestManager
      .cancelAndNew(
        `exportingStatement${type}`,
        tradeState.services.financial.downloadPartnerCommissionReportStatements({ ...query }, type as ExportListType)
      )
      .subscribe((doc) => tradeState.store.useNotificationsStore().triggerFileExportRequestNotification(doc));
  }

  if (yearForm.validation?.$invalid) {
    yearForm.validation.$touch();
  }
  if (monthForm.validation?.$invalid) {
    monthForm.validation.$touch();
  }
}

function cancel() {
  downloadStatementFormModal.value?.hide();
}

function isLoading(type: string) {
  return requestManager.requestStates[`exportingStatement${type}`] === 'pending';
}

return { __sfc: true,tradeState, requestManager, downloadStatementFormModal, apportionedForm, monthForm, yearForm, isApportioned, showModal, download, cancel, isLoading, BModal, ExportListType }
}

})